// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3O2Ki","toggleWrap":"styles_toggleWrap__3XIuh","content":"styles_content__3jGc8","selectAreaCode":"styles_selectAreaCode__2AafN"};